module.exports = __webpack_public_path__ + "static/gallery-1-7358c1188ae88c4999b562fc2596a2bd.jpg";